import { TestExecutionService } from '../../../data/services'
import { TestExecution } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { TestExecutionPresenter } from '../../../data/presenters'

export const TestExecutionConfig: IDataServiceConfig<TestExecution> = {
  service: TestExecutionService,
  deps: [ModelRepository],
  endpoint: 'exams/test_executions?filter[user-id]=:user_id',
  model: TestExecution,
  presenter: TestExecutionPresenter,
  backend: 'uncached',
  mappings: [{
    classType: 'TestExecution',
    jsonType: 'test-execution',
    propertyMapping: {
      'test-execution-results': {
        type: 'TestExecutionResult',
        isCollection: true
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/test-execution.config.ts